import { platformEnv } from '@/platform/config/env'
import { createHttpClient } from '@/platform/http/client'
import type { MembershipDraft, MembershipPlan } from '../model/membership'

const client = createHttpClient(platformEnv.courseApiUrl)

export const membershipsApi = {
  async listPlans(status?: string): Promise<MembershipPlan[]> {
    const query = status ? `?status=${encodeURIComponent(status)}` : ''
    return (await client.request<MembershipPlan[]>({ url: `/v1/admin/memberships${query}`, method: 'GET' })).data
  },
  async createPlan(draft: MembershipDraft): Promise<MembershipPlan> {
    return (await client.request<MembershipPlan>({ url: '/v1/admin/memberships', method: 'POST', data: draft })).data
  },
  async updatePlan(id: number, draft: Partial<MembershipDraft>): Promise<MembershipPlan> {
    return (await client.request<MembershipPlan>({ url: `/v1/admin/memberships/${id}`, method: 'PATCH', data: draft })).data
  },
}
